// Level codes and their display titles
export const LEVELS = [
  { code: "1.1", title: "Graduate Trainee"     },
  { code: "1.2", title: "Graduate Trainee"     },
  { code: "2.1", title: "Software Engineer"    },
  { code: "2.2", title: "Senior Software Eng." },
  { code: "3.1", title: "Tech Lead"            },
  { code: "3.2", title: "Senior Tech Lead"     },
  { code: "3.3", title: "Associate Technical Manager"       },
  { code: "4.1", title: "Technical Manager"   },
  { code: "4.2", title: "Senior Technical Manager" },
  { code: "4.3", title: "Associate Director"   },
];